import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http'; 
import { RouterModule, Routes } from '@angular/router'; 
import { AuthService } from '../../appServices/AuthService/auth.service'; 
import { authInterceptorProviders } from '../../appCommon/Interceptor/auth.interceptor';   
import {TableModule} from 'primeng/table';
import {ToastModule} from 'primeng/toast';
import {CalendarModule} from 'primeng/calendar';
import {SliderModule} from 'primeng/slider';
import {MultiSelectModule} from 'primeng/multiselect';
import {ContextMenuModule} from 'primeng/contextmenu';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {DropdownModule} from 'primeng/dropdown';
import {ProgressBarModule} from 'primeng/progressbar';
import {InputTextModule} from 'primeng/inputtext';
import {FileUploadModule} from 'primeng/fileupload';
import {ToolbarModule} from 'primeng/toolbar';
import {RatingModule} from 'primeng/rating';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputNumberModule} from 'primeng/inputnumber';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AuthGuard } from '../../appCommon/AuthGuard/auth.guard';
import { DashboardComponent } from 'src/app/appWeb/dashboard/dashboard/dashboard.component';
import { Modules } from 'src/app/appCommon/Enums/enum';
import { SharedModule } from '../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AvatarModule } from 'primeng/avatar';


const routes: Routes = [
  { path: '',

children:[
    { path: '', canActivate: [AuthGuard],data: { allowedRoles: 'dashboard' }, component: DashboardComponent },

    {path:Modules.Define,loadChildren:()=>import('src/app/appWeb/pages/define/define.module').then(d=>d.DefineModule)}

]},  
  
];

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ButtonModule,
    FormsModule,
    HttpClientModule,
    ToastModule,
    TableModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    InputTextModule,
    FileUploadModule,
    ToolbarModule,
    RatingModule,
    RadioButtonModule,
    InputNumberModule,
    ConfirmDialogModule,
    InputTextareaModule,
    SharedModule,
    MatIconModule,
    MatMenuModule,
    AvatarModule
  ],
  providers: [ConfirmationService,MessageService,AuthGuard],
})
export class DashboardModule {}
